import React, {useContext, useEffect, useState } from 'react';

import {Row, Col, DatePicker, TimePicker, Button, notification, Input, Checkbox, Form, Select} from 'antd';
import localeDatePicker from 'antd/lib/date-picker/locale/ru_RU';

import DividerBlock from "../../../divider-block";
import FieldBlock from '../../../field-block';
import InputField from "../../../input-field";
import NumberInputField from "../../../number-input-field";
import SelectField from "../../../select-field";
import Spinner from '../../../spinner';
import {priceHelper} from '../../../../helpers/price.helper';
import {YMaps, Map, ObjectManager, ZoomControl} from "react-yandex-maps";
import MaskedInput from 'antd-mask-input/build/main/lib/MaskedInput';


import {
  companyService,
  consignorService,
  deliveriesService,
  distributionCenterService,
  systemService,
  trailService
} from "../../../../services";
import {uuidHelper} from "../../../../helpers/uuid.helper";
import moment from "moment/moment";
import { DELIVERY_DEFAULT_TYPE, DELIVERY_AUCTION_PRICE_TYPE, DELIVERY_AUCTION_DATE_TYPE, REDUCTION_TYPE, DELIVERY_MULTIMODAL_TYPE, AUCTION_MULTIMODAL_TYPE, INCOTERM_EXW, INCOTERM_FOB } from '../../../../helpers/delivery.helper';
import { EXTENDED_DELIVERY_INFO } from '../../../../helpers/consignor.helpers';
import AuctionDate from './tenders/auction-date';
import AuctionPrice from './tenders/auction-price';
import Reduction from './tenders/reduction';
import Multicost from './multicost';
import MultimodalAuction from './tenders/multimodal';
import {Cost} from './multicost';
import Equipments, { Equipment } from './equipments';
import i18n from "../../../../i18n";
import MapPointSelectModal from '../../../modals/map-modal';
import {getTranslatedConstant, getTranslatedCountries} from "../../../../helpers/translate.helpers";
import {AppContext} from "../../../../contexts/app-context";

function Point(type) {

  this.uuid = uuidHelper.generateUUID();
  this.isAddressString = true;

  this.country = i18n.t('constants.countries.1');
  this.countryId = 1;
  this.portId = "";
  this.address = "";
  this.store = "";
  this.lat = "";
  this.lon = "";
  this.date = "";
  this.time = "";
  this.type = type;

}

export default function CreateDelivery({onCreate = null, deliveryOrigId, tenderToDelivery = false}) {
  const appContext = useContext(AppContext);

  const {TextArea} = Input;

  const [loading, setLoading] = useState(false);

  const [shipperCompaniesList, getShipperCompaniesList] = useState([]);
  const [shipperCompaniesListLoaded, getShipperCompaniesListLoaded] = useState(false);

  const [distributionCenterList, setDistributionCenterList] = useState([]);
  const [distributionCenterListLoaded, setDistributionCenterListLoaded] = useState(false);

  const [countyList, setCountryList] = useState([]);
  const [translatedCountryList, setTranslatedCountryList] = useState([]);
  const [countyListLoaded, setCountryListLoaded] = useState(false);

  const [paymentTypes, setPaymentTypes] = useState([]);
  const [paymentTypesLoaded, setPaymentTypesLoaded] = useState(false);

  const [carcassTypes, setCarcassTypes] = useState([]);
  const [translatedCarcassTypes, setTranslatedCarcassTypes] = useState([]);
  const [carcassTypesLoaded, setCarcassTypesLoaded] = useState(false);

  const [deliveryTypes, setDeliveryTypes] = useState([]);
  const [translatedDeliveryTypes, setTranslatedDeliveryTypes] = useState([]);
  const [deliveryTypesLoaded, setDeliveryTypesLoaded] = useState(false);

  const [portList, setPortList] = useState([]);
  const [portListLoaded, setPortListLoaded] = useState(false);

  const [incotermsList, setIncotermsList] = useState([]);
  const [incotermsListLoaded, setIncotermsListLoaded] = useState(false);

  const [hasExtendedFields, setHasExtendedFields] = useState(null);
  const [showMap, setShowMap] = useState(false);

  const [mapPointGuid, setMapPointGuid] = useState(null);

  const [packageTypesList, setPackageTypesList] = useState([]);

  const [loadingTypesList, setLoadingTypesList] = useState([]);
  const [transportationTypesList, setTransportationTypesList] = useState(null);

  const [pointEquipments, setPointEquipments] = useState({});

  useEffect(() => {
    setLoadingTypesList(getTranslatedConstant('loadingTypesList'))
    setPackageTypesList(getTranslatedConstant('packageTypesList'))
    const translatedCarcassTypes = carcassTypes.map((item) => {
      return Object.assign({}, item, {title: i18n.t(`constants.mode.${item.id}`)})
    });
    setTranslatedCarcassTypes(translatedCarcassTypes);
  }, [appContext.lang.lang]);

  let dividerStyle = {
    margin: '15px 0px 45px 0px',
    display: "block",
    clear: "both",
    width: "100%",
    minWidth: "100%",
    height: "1px"
  }

    useEffect(() => {
    if (hasExtendedFields === null) {
      consignorService.checkAccess(EXTENDED_DELIVERY_INFO)
        .then(res => {
          setHasExtendedFields(res.access);
        })
        .catch(errMsg => {
        });
    }
    }, []);

  useEffect(() => {
    if (!shipperCompaniesListLoaded) {
      consignorService.getShipperCompaniesList()
        .then(res => {
          getShipperCompaniesListLoaded(true);
          getShipperCompaniesList(res);
        })
        .catch(errMsg => {
          getShipperCompaniesListLoaded(true);
          notification.error(
            {
              message: i18n.t('components.notification.titles.getShipperCompaniesListLoaded'),
              description: errMsg
            });
        });
    }
  }, []);

  useEffect(() => {
    if (!distributionCenterListLoaded) {
      distributionCenterService.getCompanies()
        .then(res => {
          setDistributionCenterListLoaded(true);
          setDistributionCenterList(res);
        })
        .catch(errMsg => {
          setDistributionCenterListLoaded(true);
          notification.error(
            {
              message: i18n.t('components.notification.titles.getDistributionCentersList'),
              description: errMsg
            });
        });
    }
  }, []);

  useEffect(() => {
    setTranslatedCountryList(getTranslatedCountries(countyList));
  },[appContext.lang.lang])

  useEffect(() => {
    if (!countyListLoaded) {
      systemService
        .getCountryList()
        .then(response => {
          setCountryList(response);
          setTranslatedCountryList(getTranslatedCountries(response));
          setCountryListLoaded(true);
        })
        .catch(errorMsg => {
          notification.error({
            message: i18n.t('components.notification.titles.getCountryList'),
            description: errorMsg,
          });
        });
    }
  }, []);

  useEffect(() => {
    if (!incotermsListLoaded) {
      systemService
        .getIncotermsTypes()
        .then(response => {
          setIncotermsList(response);
          setIncotermsListLoaded(true);
        })
        .catch(errorMsg => {
          notification.error({
            message: "Получение условий поставки",
            description: errorMsg,
          });
        });
    }
  }, []);

  useEffect(() => {
    if (!portListLoaded) {
      systemService
        .getPortList()
        .then(response => {
          setPortList(response);
          setPortListLoaded(true);
        })
        .catch(errorMsg => {
          notification.error({
            message: "Получение списка портов",
            description: errorMsg,
          });
        });
    }
  }, []);

  useEffect(() => {
    if (!carcassTypesLoaded) {
      trailService
        .getTrailTypes()
        .then((response) => {
          const translatedCarcassTypes = response.map((item) => {
            return Object.assign({}, item, {title: i18n.t(`constants.mode.${item.id}`)})
          });
          setTranslatedCarcassTypes(translatedCarcassTypes);
          setCarcassTypes(response);
          setCarcassTypesLoaded(true);
        })
        .catch((errorMsg) => {
          notification.error({
            message: i18n.t('components.notification.titles.getTrailTypes'),
            description: errorMsg,
          });
        });
    }
  }, []);

  useEffect(() => {
    if (deliveryTypesLoaded) {
      const translatedTypes = deliveryTypes.map((type) => {
        return Object.assign(type, {title: i18n.t(`constants.deliveryType.${type.id}`)})
      });
      setTranslatedDeliveryTypes(translatedTypes);
    }
  }, [appContext.lang.lang]);

  useEffect(() => {
    if (!deliveryTypesLoaded) {
      deliveriesService
        .getTypes()
        .then((response) => {
          const translatedTypes = response.map((type) => {
            return Object.assign(type, {title: i18n.t(`constants.deliveryType.${type.id}`)})
          });
          setDeliveryTypes(response);
          setTranslatedDeliveryTypes(translatedTypes);
          setDeliveryTypesLoaded(true);
        })
        .catch((errorMsg) => {
          notification.error({
            message: i18n.t('components.notification.titles.getTypes'),
            description: errorMsg,
          });
        });
    }
  }, []);

  useEffect(() => {
    if (!paymentTypesLoaded) {
      systemService
        .getPaymentTypes()
        .then((response) => {
          setPaymentTypes(response);
          setPaymentTypesLoaded(true);
        })
        .catch((errorMsg) => {
          notification.error({
            message: i18n.t('components.notification.titles.getPaymentTypes'),
            description: errorMsg,
          });
        });
    }
  }, []);

  useEffect(() => {
    if (!transportationTypesList) {
      systemService
        .getTransportationTypes()
        .then((response) => {
          setTransportationTypesList(response);
        })
        .catch((errorMsg) => {
          setTransportationTypesList([]);
          notification.error({
            message: i18n.t('components.notification.titles.getPaymentTypes'),
            description: errorMsg,
          });
        });
    }
  }, []);

  // Если передали в параметрах id рейса, то берем дефолтные данные формы из него
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const deliveryID = urlParams.get('deliveryID') || deliveryOrigId;

    if (deliveryID) {
      deliveriesService
        .getInfoDelivery(deliveryID)
        .then(resp => {
          setNumber(resp.NumberDelivery);
          setWeight(resp.Weight);
          setVolume(resp.Volume);
          setPackageType(resp.PackageType);
                    setCargoName(resp.CargoName);
          setLoadingType(resp.UnloadingType);
          setComments(resp.Comments);
          setShipperCompanyId(resp.CustomerCompanyID);
          setDistributionCenterId(resp.DistributionCenter.Id);
          setAllowedCarcassTypes(resp.AllowedCarcassTypes.map(value => {
            return value.Id;
          }));
          setAssessedValue(resp.AssessedVal);
          setNdsPrice(resp.NdsPrice);
          setNoNdsPrice(resp.NoNdsPrice);
          setCashPrice(resp.CashPrice);
          setNds5Price(resp.Prices.find(e => e.PaymentType.Type === 'nds-5').Price || null);
          setNds7Price(resp.Prices.find(e => e.PaymentType.Type === 'nds-7').Price || null);

          // Точки рейса
          let pointsArr = [...points];
          // Добавить данные для первой точки загрузки
          pointsArr[0].address = resp.PlaceLoad.Address;
          pointsArr[0].lat = resp.PlaceLoad.CoordinateLat;
          pointsArr[0].lon = resp.PlaceLoad.CoordinateLon;
          pointsArr[0].country = resp.PlaceLoad.Country.Name;
          pointsArr[0].countryId = resp.PlaceLoad.Country.Id;

          resp.PlacesUnload.forEach((value, index) => {
            const pointIndexInArr = index + 1;
            let newPoint;
            if (pointsArr.hasOwnProperty(pointIndexInArr)) {
              newPoint = pointsArr[pointIndexInArr];
              newPoint.type = value.Type;
            } else {
              newPoint = new Point(value.Type);
            }
                        newPoint.address = value.Address;
                        newPoint.lat = value.CoordinateLat;
                        newPoint.lon = value.CoordinateLon;
                        newPoint.country = value.Country.Name;
                        newPoint.countryId = value.Country.Id;
                        newPoint.uuid = value.Guid;

                        pointsArr[pointIndexInArr] = newPoint;
                    })
                    // Обновить точки рейса
                    setPoints(pointsArr);

                    if(resp.IsMulticost) {
                      let costsArr = [];
                      resp.Costs.forEach((value, index) => {
                        let newCost = new Cost();
                        newCost.name = value.Name;
                        newCost.required = value.Required;
                        costsArr.push(newCost);
                      });
                      setCosts(costsArr);
                    }

                    if(resp.IsMultimodal) {
                      setIsMultimodal(resp.IsMultimodal);
                      setMultimodalFlags({
                        considerTaxType: resp.Multimodal.flags.considerTaxType,
                        considerOrgForm: resp.Multimodal.flags.considerOrgForm,
                        considerCountry: resp.Multimodal.flags.considerCountry,
                        insurance: resp.Multimodal.flags.insurance,
                      });
                      setTnvdCodes(resp.Multimodal.tnvdCodes);

                      let contArr = [];
                      let number = 1;
                      resp.Multimodal.equipments.forEach((value, index) => {
                        let newCont = new Equipment(number, translatedCarcassTypes);
                        newCont.type = value.typeId;
                        newCont.points = value.points;
                        newCont.weight = value.weight;
                        contArr.push(newCont);
                        number++;
                      });
                      setEquipments(contArr);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        }
    }, []);

  const [shipperCompanyId, setShipperCompanyId] = useState(null);
  const [distributionCenterId, setDistributionCenterId] = useState(null);
  const [countryDeparture, setCountryDeparture] = useState(null);
  const [addressWarehouse, setAddressWarehouse] = useState(null);
  const [coordinateLoadLat, setCoordinateLoadLat] = useState('');
  const [coordinateLoadLon, setCoordinateLoadLon] = useState('');
  const [number, setNumber] = useState(null);
  const [number1C, setNumber1C] = useState(null);
  const [weight, setWeight] = useState('');
  const [volume, setVolume] = useState('');
  const [packageType, setPackageType] = useState(null);
  const [cargoName, setCargoName] = useState('');
  const [ndsPrice, setNdsPrice] = useState(null);
  const [nds5Price, setNds5Price] = useState(null);
  const [nds7Price, setNds7Price] = useState(null);
  const [noNdsPrice, setNoNdsPrice] = useState(null);
  const [cashPrice, setCashPrice] = useState(null);
  const [maxPrice, setMaxPrice] = useState(null);
  const [stepPrice, setStepPrice] = useState(null);
  const [loadingType, setLoadingType] = useState(null);
  const [dateShipment, setDateShipment] = useState(null);
  const [comments, setComments] = useState('');
  const [costComment, setCostComment] = useState('');
  // const [partialCargo, setPartialCargo] = useState(false);
  const [assessedValue, setAssessedValue] = useState('');
  const [allowedCarcassTypes, setAllowedCarcassTypes] = useState([]);
  const [deliveryType, setDeliveryType] = useState(DELIVERY_DEFAULT_TYPE);
  const [needUpdateDate, setNeedUpdateDate] = useState(true);
  const [isMulticost, setIsMulticost] = useState(false);
  const [isMultimodal, setIsMultimodal] = useState(false);
  const [multimodalFlags, setMultimodalFlags] = useState({
    considerTaxType: false,
    considerOrgForm: false,
    considerCountry: false,
    insurance: false,
  });
  const [totalCost, setTotalCost] = useState(null);
  const [rate, setRate] = useState(null);
  const [tnvdCodes, setTnvdCodes] = useState([]);
  const [consignor, setConsignor] = useState('');
  const [consignee, setConsignee] = useState('');
  const [sameConsignee, setSameConsignee] = useState(true);
  const [packageDesc, setPackageDesc] = useState('');
  const [packageSize, setPackageSize] = useState('');
  const [weightDesc, setWeightDesc] = useState('');
  const [incoterm, setIncoterm] = useState(INCOTERM_EXW);
  const [transportationType, setTransportationType] = useState([]);

  //Параметры аукциона
  const [loadStart, setLoadStart] = useState(null);
  const [loadEnd, setLoadEnd] = useState(null);
  const [tenderStart, setTenderStart] = useState(null);
  const [tenderEnd, setTenderEnd] = useState(null);
  const [tenderTimeStart, setTenderTimeStart] = useState(moment('09:00', 'HH:mm'));
  const [tenderTimeEnd, setTenderTimeEnd] = useState(moment('18:00', 'HH:mm'));
  const [fieldsErrors, setFieldsErrors] = useState([]);

  const [points, setPoints] = useState([new Point("load"), new Point("unload")])
  const [costs, setCosts] = useState([new Cost()]);
  const [equipments, setEquipments] = useState([]);
  const [maxPointsUnload, setMaxPointsUnload] = useState(2);
  const [maxPointsLoad, setMaxPointsLoad] = useState(2);

  const getFieldErrors = (nameField) => {
    return (fieldsErrors && typeof fieldsErrors[nameField] !== "undefined")
      ? fieldsErrors[nameField][0]
      : null;
  };

  const getPointErrors = (nameField, pointKey) => {
    return (fieldsErrors && typeof fieldsErrors[pointKey] !== "undefined" && typeof fieldsErrors[pointKey][nameField] !== "undefined")
      ? fieldsErrors[pointKey][nameField][0]
      : null;
  };

  const updatePrices = (value, alias) => {

    let currentPay = paymentTypes[alias];
    let noTaxPrice = priceHelper.withoutTax(value, currentPay.isTax, currentPay.taxPercent);

    if (!ndsPrice) {
      setNdsPrice(priceHelper.withTax(noTaxPrice, paymentTypes['nds'].isTax, paymentTypes['nds'].taxPercent));
    }
    if (!nds7Price) {
      setNds7Price(priceHelper.withTax(noTaxPrice, paymentTypes['nds-7'].isTax, paymentTypes['nds-7'].taxPercent));
    }
    if (!nds5Price) {
      setNds5Price(priceHelper.withTax(noTaxPrice, paymentTypes['nds-5'].isTax, paymentTypes['nds-5'].taxPercent));
    }
    if (!noNdsPrice) {
      setNoNdsPrice(priceHelper.withTax(noTaxPrice, paymentTypes['no-nds'].isTax, paymentTypes['no-nds'].taxPercent));
    }
    if (!cashPrice) {
      setCashPrice(priceHelper.withTax(noTaxPrice, paymentTypes['cash'].isTax, paymentTypes['cash'].taxPercent));
    }
  };

  useEffect(() => {
      if (deliveryType === AUCTION_MULTIMODAL_TYPE || deliveryType === DELIVERY_MULTIMODAL_TYPE) {
        setIsMultimodal(true);
      } else {
        setIsMultimodal(false);
        setNumber1C(null);
      }
    }, [deliveryType]);

  const saveDelivery = () => {
    setLoading(true);

    deliveriesService.createDelivery(
      {
        ShipperCompanyId: shipperCompanyId,
        DistributionCenterId: distributionCenterId,
        CountryDeparture: countryDeparture ? translatedCountryList.find(element => {
          return element.Id === countryDeparture;
        }).Name : '',
        AddressWarehouse: addressWarehouse,
        CoordinateLoadLat: coordinateLoadLat,
        CoordinateLoadLon: coordinateLoadLon,
        Number: number1C || number,
        NumberDelivery: number,
        Weight: weight,
        Volume: volume,
        NdsPrice: ndsPrice,
        NoNdsPrice: noNdsPrice,
        Nds5Price: nds5Price,
        Nds7Price: nds7Price,
        CashPrice: cashPrice,
        LoadingType: loadingType,
        DateShipment: dateShipment,
        Comments: comments,
        CostComment: costComment,
        Points: points,
        PackageType: packageType,
        CargoName: cargoName,
        AssessedValue: assessedValue,
        AllowedCarcassTypes: allowedCarcassTypes,
        NeedUpdateDate: needUpdateDate,
        IsMulticost: isMulticost,
        MultimodalFlags: multimodalFlags,
        TnvdCodes: tnvdCodes,
        Consignor: consignor,
        Consignee: consignee,
        PackageDesc: packageDesc,
        PackageSize: packageSize,
        WeightDesc: weightDesc,
        Incoterm: incoterm,
        TransportationType: transportationType,
        Rate: rate,
        TotalCost: totalCost,
        Costs: costs,
        Equipments: equipments,
        DeliveryType: deliveryType,
        loadStart: loadStart,
        loadEnd: loadEnd,
        tenderStart: tenderStart,
        tenderEnd: tenderEnd,
        tenderTimeStart: tenderTimeStart.format('HH:mm'),
        tenderTimeEnd: tenderTimeEnd.format('HH:mm'),
        MaxPrice: maxPrice,
        StepPrice: stepPrice,
      }
    )
      .then(response => {
        setLoading(false);
        if (response.code === 400) {
          notification.error({
            message: i18n.t('components.notification.titles.createDelivery'),
            description: response.message,
          });
          setFieldsErrors(response.errors);
        } else {
          notification.success({
            message: i18n.t('components.notification.titles.createDelivery'),
            description: response.message,
          });

          if (typeof onCreate === 'function') {
            onCreate();
          }

          setTimeout(document.location.reload(), 2000);
        }

      })
      .catch(errMsg => {
        setLoading(false);

        notification.error({
          message: i18n.t('components.notification.titles.createDelivery'),
          description: errMsg,
        });
      });

  };

  const turnTenderToDelivery = () => {
    setLoading(true);

    deliveriesService.auctionToDelivery(
      {
        DeliveryId: deliveryOrigId,
        ShipperCompanyId: shipperCompanyId,
        DistributionCenterId: distributionCenterId,
        CountryDeparture: countryDeparture ? translatedCountryList.find(element => {
          return element.Id === countryDeparture;
        }).Name : '',
        AddressWarehouse: addressWarehouse,
        CoordinateLoadLat: coordinateLoadLat,
        CoordinateLoadLon: coordinateLoadLon,
        Number: number,
        NumberDelivery: number,
        Weight: weight,
        Volume: volume,
        CargoName: cargoName,
        NdsPrice: ndsPrice,
        NoNdsPrice: noNdsPrice,
        Nds5Price: nds5Price,
        Nds7Price: nds7Price,
        CashPrice: cashPrice,
        LoadingType: loadingType,
        DateShipment: dateShipment,
        Comments: comments,
        CostComment: costComment,
        Points: points,
        PackageType: packageType,
        AssessedValue: assessedValue,
        AllowedCarcassTypes: allowedCarcassTypes,
        NeedUpdateDate: needUpdateDate,
        IsMulticost: isMulticost,
        Costs: costs,
        Equipments: equipments,
        MultimodalFlags: multimodalFlags,
        TnvdCodes: tnvdCodes,
        Consignor: consignor,
        Consignee: consignee,
        PackageDesc: packageDesc,
        PackageSize: packageSize,
        WeightDesc: weightDesc,
        Incoterm: incoterm
      }
    )
      .then(response => {
        setLoading(false);
        if (response.code === 400) {
          notification.error({
            message: i18n.t('components.notification.titles.auctionToDelivery'),
            description: response.message,
          });
          setFieldsErrors(response.errors);
        } else {
          notification.success({
            message: i18n.t('components.notification.titles.auctionToDelivery'),
            description: response.message,
          });

          if (typeof onCreate === 'function') {
            onCreate();
          }

          setTimeout(document.location.reload(), 2000);
        }

      })
      .catch(errMsg => {
        setLoading(false);

        notification.error({
          message: i18n.t('components.notification.titles.auctionToDelivery'),
          description: errMsg,
        });
      });

  };

  useEffect(() => {
    if(isMultimodal) {
      setIsMulticost(true);
    }
  }, [isMultimodal])

  let bigButtonStyle = { width: '200px', height: '43px', background: '#1CAA53', position: 'static', borderRadius: '10px', borderColor: 'transparent', boxShadow: 'none' };

  const renderMulticost = () => {
    if(isMulticost) {
      return (
        <Multicost isMultimodal={isMultimodal} costs={costs} setCosts={setCosts} costComment={costComment} setCostComment={setCostComment} fieldsErrors={fieldsErrors}/>
      );
    }
  }

  const renderTender = () => {
    switch (deliveryType) {
      case REDUCTION_TYPE:
        return (
          <Reduction
            tenderStart={tenderStart}
            tenderEnd={tenderEnd}
            tenderTimeStart={tenderTimeStart}
            tenderTimeEnd={tenderTimeEnd}
            setTenderStart={setTenderStart}
            setTenderEnd={setTenderEnd}
            setTenderTimeStart={setTenderTimeStart}
            setTenderTimeEnd={setTenderTimeEnd}
            maxPrice={maxPrice}
            stepPrice={stepPrice}
            setMaxPrice={setMaxPrice}
            setStepPrice={setStepPrice}
            getFieldErrors={getFieldErrors}
            dividerStyle={dividerStyle}
          />
        );
      case DELIVERY_AUCTION_DATE_TYPE:
        return (
          <AuctionDate
            loadStart={loadStart}
            loadEnd={loadEnd}
            tenderStart={tenderStart}
            tenderEnd={tenderEnd}
            tenderTimeStart={tenderTimeStart}
            tenderTimeEnd={tenderTimeEnd}
            setLoadStart={setLoadStart}
            setLoadEnd={setLoadEnd}
            setTenderStart={setTenderStart}
            setTenderEnd={setTenderEnd}
            setTenderTimeStart={setTenderTimeStart}
            setTenderTimeEnd={setTenderTimeEnd}
            getFieldErrors={getFieldErrors}
            dividerStyle={dividerStyle}
          />
        );
      case DELIVERY_AUCTION_PRICE_TYPE:
        return (
          <AuctionPrice
            loadStart={loadStart}
            loadEnd={loadEnd}
            tenderStart={tenderStart}
            tenderEnd={tenderEnd}
            tenderTimeStart={tenderTimeStart}
            tenderTimeEnd={tenderTimeEnd}
            setLoadStart={setLoadStart}
            setLoadEnd={setLoadEnd}
            setTenderStart={setTenderStart}
            setTenderEnd={setTenderEnd}
            setTenderTimeStart={setTenderTimeStart}
            setTenderTimeEnd={setTenderTimeEnd}
            getFieldErrors={getFieldErrors}
            dividerStyle={dividerStyle}
          />
        );
        case AUCTION_MULTIMODAL_TYPE:
            return (
              <MultimodalAuction
              loadStart={loadStart}
              loadEnd={loadEnd}
              tenderStart={tenderStart}
              tenderEnd={tenderEnd}
              tenderTimeStart={tenderTimeStart}
              tenderTimeEnd={tenderTimeEnd}
              setLoadStart={setLoadStart}
              setLoadEnd={setLoadEnd}
              setTenderStart={setTenderStart}
              setTenderEnd={setTenderEnd}
              setTenderTimeStart={setTenderTimeStart}
              setTenderTimeEnd={setTenderTimeEnd}
              stepPrice={stepPrice}
              setStepPrice={setStepPrice}
              getFieldErrors={getFieldErrors}
              dividerStyle={dividerStyle}
            />
            );
      default:
        return null;
    }
  };

  const updatePointsPoint = (key, value, uuid) => {
      const newPointsUnload = [...points];
      newPointsUnload.forEach((e, i) => {
          if (e.uuid === uuid) {
              newPointsUnload[i][key] = value;
              setPoints(newPointsUnload);
          }
      });
  };

  const updatePointsEquipments = (values, uuid) => {
      const newPointsEquipments = {...pointEquipments};
      const currentValues = {...newPointsEquipments[uuid]};
      newPointsEquipments[uuid] = {}
      values.forEach((v) => {
        if (!newPointsEquipments[uuid][v]) {
          newPointsEquipments[uuid][v] = currentValues[v] || null;
        }
      });
      setPointEquipments(newPointsEquipments);
  };

  const renderPoints = (pointsArr, setPointsArr, maxPoints, setMaxPoints, type) => {
    const removePointUnload = (uuid) => {
      pointsArr.forEach((e, i) => {
        if (i > 1) {
          if (e.uuid === uuid) {
            const newPoints = [...pointsArr];
            newPoints.splice(i, 1);
            setPointsArr(newPoints);
            setMaxPoints(maxPoints - 1);
          }
        }
      });
      updatePointsEquipments([], uuid);
    };

    const changeAddressType = (isAddressString, uuid) => {
      updatePointsPoint('isAddressString', isAddressString, uuid);

      updatePointsPoint('lat', 0, uuid);
      updatePointsPoint('lon', 0, uuid);
      updatePointsPoint('address', '', uuid);

    }

    const renderPointEquipmentWeight = (dataArray, pointUuid) => {
      let weights = [];
      if(dataArray) {
        Object.keys(dataArray).forEach((c) => {
          let equipment = equipments.find((cont) => cont.Id === c);
          weights.push(
          <Row style={{verticalAlign: "bottom", margin: "0px", marginTop: "10px"}}>
            <Col sm={12}>
              <br/>
              <p>{equipment.Name}</p>
            </Col>
            <Col sm={12}>
              <InputField
                name="store" placeholder="Вес, выгружаемый на точке"
                value={dataArray[c]} setValue={(v) => {
                  const newPointsEquipments = {...pointEquipments};
                  newPointsEquipments[pointUuid][c] = v;
                  setPointEquipments(newPointsEquipments);
                }}
                keyNum={c}
                getFieldErrors={getPointErrors}
              />
            </Col>
          </Row>
          );
        });
      }

      return (
        weights
      )
    };


    return pointsArr.filter((point) => point.type === type).map((point, i) => (
      <div style={{border: '1px solid rgba(0, 0, 0, 0.1)', margin: '10px', padding: '15px'}} key={`point-${i}`}>
        <Row gutter={[16, 24]} key={i + 1}>
          <Col lg={12} md={24} sm={24} sx={24} style={{float: 'left'}}>
            <span>{i18n.t(`consignorPage.createDelivery.content.point.${point.type === 'load' ? 'onLoad' : 'upLoad'}`, {number: i + 1})}</span>
          </Col>
          <Col lg={12} md={24} sm={24} sx={24}>
            <Button
              type="danger"
              icon="close"
              onClick={() => removePointUnload(point.uuid)}
              style={{...bigButtonStyle, backgroundColor: 'red', color: 'white', float: 'right', width: '50px'}}
            />
            <Button
                type="primary"
                size='small'
                onClick={() => {
                  changeAddressType(false, point.uuid);
                  setMapPointGuid(point.uuid);
                  setShowMap(true);
                }}
                style={{ ...bigButtonStyle, color: 'white', float: 'right', marginRight: '10px'}}
            >
              {i18n.t('consignorPage.createDelivery.buttons.map')}
            </Button>
          </Col>

          <Col lg={12} md={24} sm={24} sx={24}>
            <SelectField
              title={i18n.t('consignorPage.createDelivery.content.country')}
              name="country"
              selectedValue={point.countryId}
              values={translatedCountryList}
              keyNum={point.uuid}
              onChange={(value, option) => {
                updatePointsPoint('countryId', value, point.uuid);
                updatePointsPoint('country', option.props.children, point.uuid);
                updatePointsPoint('portId', "", point.uuid);
              }}
              getErrors={getPointErrors}
              style={{width: "100%"}}
            />
          </Col>

          {(deliveryType !== DELIVERY_AUCTION_DATE_TYPE && deliveryType !== AUCTION_MULTIMODAL_TYPE) &&
            <>
            <Col lg={hasExtendedFields ? 6 : 12} md={24} sm={24} sx={24}>
              <FieldBlock keyNum={point.uuid} name="date"
                          title={point.type === 'load' ? i18n.t(`consignorPage.createDelivery.content.${isMultimodal ? 'dateDeparture' : 'dateOnLoad'}`) : i18n.t('consignorPage.createDelivery.content.dateUpLoad')}
                          getErrors={getPointErrors}>
                <DatePicker
                  style={{width: "100%"}}
                  format="DD.MM.YYYY"
                  size="large"
                  name="date"
                  allowClear={false}
                  onChange={value => updatePointsPoint('date', value, point.uuid)}
                />
              </FieldBlock>
            </Col>
            {(hasExtendedFields) &&
            <Col lg={6} md={24} sm={24} sx={24}>
              <FieldBlock keyNum={point.uuid} name="date"
                          title={point.type === 'load' ? i18n.t('consignorPage.createDelivery.content.timeOnLoad') : i18n.t('consignorPage.createDelivery.content.timeUpLoad')}
                          getErrors={getPointErrors}>
                <MaskedInput 
                  keyNum={point.uuid} 
                  name="time" 
                  title={point.type === 'load' ? i18n.t('consignorPage.createDelivery.content.timeOnLoad') : i18n.t('consignorPage.createDelivery.content.timeUpLoad')}
                  mask="11:11"
                  minLength={5}
                  size='large'
                  value={point.time}
                  placeholder={point.type === 'load' ? i18n.t('consignorPage.createDelivery.content.timeOnLoad') : i18n.t('consignorPage.createDelivery.content.timeUpLoad')}
                  onChange={(e) => {
                    let unm = e.target.value.replace(/[^0-9]/g, "");
                    if(unm.length !== 4) {
                      updatePointsPoint('time', '', point.uuid);
                    } else {
                      updatePointsPoint('time', e.target.value, point.uuid);
                    }
                  }}
                  onBlur={(e) => {
                    e.stopPropagation();
                    let unm = e.target.value.replace(/[^0-9]/g, "");
                    if(unm.length !== 4) {
                      e.target.value = '';
                    }
                  }}
                  style={{ width: "100%" }}
                />
              </FieldBlock>
              </Col>
            }
            </>
          }
          {(hasExtendedFields && point.type === 'unload') && <Col lg={24} md={24} sm={24} sx={24}>
            <InputField
              name="store" label={i18n.t('consignorPage.createDelivery.content.store')}
              value={point.store} setValue={value => updatePointsPoint('store', value, point.uuid)}
              keyNum={point.uuid}
              getFieldErrors={getPointErrors}
            />
          </Col>}

          {!(isMultimodal && type === 'load' && incoterm === INCOTERM_FOB) && <><Col lg={24} md={24} sm={24} sx={24} style={{float: 'left'}}>
            <div>
              <div className="form-switch form-switch--role">
                <input
                  value={true}
                  className="form-switch-input"
                  type="radio"
                  name={"isAddressString" + point.uuid}
                  id={"isAddressString" + point.uuid}
                  checked={point.isAddressString}
                  onChange={() => changeAddressType(true, point.uuid)}
                />
                <label className="form-switch-label" htmlFor={"isAddressString" + point.uuid}>
                  <span className="only-desktop">{i18n.t('consignorPage.createDelivery.content.address')}</span>
                  <span className="only-mobile">{i18n.t('consignorPage.createDelivery.content.address')}</span>
                </label>
                <input
                  value={false}
                  className="form-switch-input"
                  type="radio"
                  name={"isAddressString" + point.uuid}
                  id={"isAddressCoordinates" + point.uuid}
                  checked={!point.isAddressString}
                  onChange={() => changeAddressType(false, point.uuid)}
                />
                <label className="form-switch-label" htmlFor={"isAddressCoordinates" + point.uuid}>
                  <span
                    className="only-desktop">{i18n.t('consignorPage.createDelivery.content.coordinate.name.full')}</span>
                  <span
                    className="only-mobile">{i18n.t('consignorPage.createDelivery.content.coordinate.name.shot')}</span>
                </label>
              </div>
            </div>
          </Col>
          <Col lg={24} md={24} sm={24} sx={24}>
            <InputField
              name="address" label={point.type === 'load' ? i18n.t('consignorPage.createDelivery.content.detailAddress.onload') : i18n.t('consignorPage.createDelivery.content.detailAddress.upLoad')}
              value={point.address} setValue={value => updatePointsPoint('address', value, point.uuid)}
              keyNum={point.uuid}
              getFieldErrors={getPointErrors}
            />
          </Col>
          {!point.isAddressString &&
            (
              <>
                <Col lg={12} md={24} sm={24} sx={24}>
                  <InputField
                    name="latitude" label={i18n.t('consignorPage.createDelivery.content.coordinate.latitude')}
                    value={point.lat} setValue={value => updatePointsPoint('lat', value, point.uuid)}
                    keyNum={point.uuid}
                    getFieldErrors={getPointErrors}
                  />
                </Col>
                <Col lg={12} md={24} sm={24} sx={24}>
                  <InputField
                    name="longitude" label={i18n.t('consignorPage.createDelivery.content.coordinate.longitude')}
                    value={point.lon} setValue={value => updatePointsPoint('lon', value, point.uuid)}
                    keyNum={point.uuid}
                    getFieldErrors={getPointErrors}
                  />
                </Col>
              </>
            )
            }</>}
            {(isMultimodal && type === 'load' && incoterm === INCOTERM_FOB) && <Col lg={24} md={24} sm={24} sx={24}>
            <SelectField
              title="Порт"
              name="portId"
              selectedValue={point.portId}
              values={portList[point.countryId]}
              keyNum={point.uuid}
              onChange={(value, option) => {
                updatePointsPoint('portId', value, point.uuid);
              }}
              getErrors={getPointErrors}
              style={{width: "100%"}}
            />
          </Col>}
        </Row >
        {(isMultimodal && point.type === 'unload') && <Row>
          <Col>
            <SelectField
                mode="multiple"
                title={i18n.t('Выгружается на точке')}
                name={'equipments.' + point.uuid}
                keyNum={point.uuid}
                selectedValue={pointEquipments[point.uuid] ? Object.keys(pointEquipments[point.uuid]) : []}
                values={equipments}
                onChange={(value) => {
                  updatePointsEquipments([...value], point.uuid)
                }}
                getErrors={getFieldErrors}
                style={{ width: "100%" }}
            />
          </Col>
          {renderPointEquipmentWeight(pointEquipments[point.uuid], point.uuid)}
        </Row>}
      </div >
    ));
  };

  const renderPointsAddButton = (points, setPoints, type, maxPoints, setMaxPoints) => {
    const addPointUnload = () => {
      if (maxPoints <= 15) {
        const newPointsUnload = [...points];
        newPointsUnload.push(new Point(type));
        setPoints(newPointsUnload);
        setMaxPoints(parseInt(maxPoints) + 1);
      }
    };

    if(isMultimodal && type === 'load') {
      return null;
    }

    if (maxPoints <= 20) {
      return (
        <Row gutter={[16, 24]} style={{marginBottom: '60px'}}>
          <Col lg={24} md={24} sm={24} sx={24} style={{textAlign: 'center'}}>
            <Button type="primary" size="small" htmlType="button" onClick={addPointUnload} style={{...bigButtonStyle}}>
              {i18n.t('consignorPage.createDelivery.buttons.addPoint')}
            </Button>
          </Col>
        </Row>
      );
    } else {
      return null;
    }
  }

  return (
    <Spinner loading={(!shipperCompaniesListLoaded && !distributionCenterListLoaded) || loading}
              tip={i18n.t('main.loadText.loading')}>
      {!tenderToDelivery &&
        <Row gutter={[16, 24]}>
          <Col lg={24} md={24} sm={24} sx={24}>
            <SelectField
              name="deliveryType"
              title={i18n.t('consignorPage.createDelivery.content.deliveryType')}
              values={translatedDeliveryTypes}
              selectedValue={deliveryType}
              onChange={(value) => {
                setDeliveryType(value);
              }}
              getErrors={getFieldErrors}
              style={{width: "100%"}}
            />
          </Col>
        </Row>}
    {isMultimodal && <>
      <span className="divider-label">Настройки мультимодальности</span>
      <DividerBlock style={dividerStyle} />

      <Row>
        <Col lg={24} md={24} sm={24} sx={24}>
          <FieldBlock name={"consignor"} getErrors={getFieldErrors}>
            <span className="form-field-label">Грузоотправитель</span>
            <TextArea
              placeholder="Грузоотправитель"
              value={consignor}
              onChange={(e) => {
                setConsignor(e.target.value)
              }}
              autoSize={{minRows: 4, maxRows: 8}}
            />
          </FieldBlock>
        </Col>
      </Row>

      <Row gutter={[16, 24]}>
        <Col lg={24} md={24} sm={24} sx={24}>
          <SelectField
            title="Условия поставки"
            name="incoterm"
            selectedValue={incoterm}
            values={incotermsList}
            onChange={value => {
              setIncoterm(value);
            }}
            getErrors={getFieldErrors}
            style={{width: "100%"}}
          />
        </Col>
      </Row>
  
      <Row gutter={[16, 24]} >
        <Col lg={12} md={24} sm={24} sx={24}>
          <NumberInputField
            name="totalCost" label="Общая стоимость (РУБ)"
            value={totalCost} setValue={setTotalCost}
            getFieldErrors={getFieldErrors}
          />
        </Col>
        <Col lg={12} md={24} sm={24} sx={24}>
          <NumberInputField
            name="rate" label="Курс валюты $"
            value={rate} setValue={setRate}
            getFieldErrors={getFieldErrors}
            step={0.01}
          />
        </Col>
      </Row>
      <Row gutter={[16, 24]}>
          <Col lg={6} md={24} sm={24} sx={24}>
              <Checkbox
                  name="multimodalFlags.considerTaxType"
                  checked={multimodalFlags.considerTaxType}
                  onChange={(e) => {
                      setMultimodalFlags({...multimodalFlags, considerTaxType: e.target.checked});
                  }}
                  style={{fontSize: "10pt", paddingTop: "15px"}}
              >
                Только НДС 22%
              </Checkbox>
          </Col>
          <Col lg={6} md={24} sm={24} sx={24}>
              <Checkbox
                  name="multimodalFlags.considerOrgForm"
                  checked={multimodalFlags.considerOrgForm}
                  onChange={(e) => {
                      setMultimodalFlags({...multimodalFlags, considerOrgForm: e.target.checked});
                  }}
                  style={{fontSize: "10pt", paddingTop: "15px"}}
              >
                Только ООО
              </Checkbox>
          </Col>
          <Col lg={6} md={24} sm={24} sx={24}>
              <Checkbox
                  name="multimodalFlags.considerCountry"
                  checked={multimodalFlags.considerCountry}
                  onChange={(e) => {
                      setMultimodalFlags({...multimodalFlags, considerCountry: e.target.checked});
                  }}
                  style={{fontSize: "10pt", paddingTop: "15px"}}
              >
                Только РФ компании
              </Checkbox>
          </Col>
          <Col lg={6} md={24} sm={24} sx={24}>
              <Checkbox
                  name="multimodalFlags.insurance"
                  checked={multimodalFlags.insurance}
                  onChange={(e) => {
                      setMultimodalFlags({...multimodalFlags, insurance: e.target.checked});
                  }}
                  style={{fontSize: "10pt", paddingTop: "15px"}}
              >
                Страховка
              </Checkbox>
          </Col>
      </Row>
      <Row gutter={[16, 24]} >
        <Col lg={24} md={24} sm={24} sx={24}>
          <FieldBlock name={"tnvdCodes"} getErrors={getFieldErrors}>
            <span className="form-field-label">Коды ТН ВЭД</span>
            <Select
              name={"tnvdCodes"}
              title="Коды ТН ВЭД"
              mode="tags"
              style={{ width: '100%' }}
              placeholder="Коды ТН ВЭД"
              size='large'
              options={tnvdCodes}
              value={tnvdCodes}
              onChange={(value) => {
                  setTnvdCodes([...value]);
              }}
              getErrors={getFieldErrors}
            />
          </FieldBlock>
        </Col>
      </Row>
      </>}
      <span className="divider-label">{i18n.t('consignorPage.createDelivery.content.divider.main')}</span>
      <DividerBlock style={dividerStyle}/>

      <Row gutter={[16, 24]}>
        <Col lg={12} md={24} sm={24} sx={24}>
          <SelectField
            title={i18n.t('consignorPage.createDelivery.content.shipperCompanyId')}
            name="shipperCompanyId"
            selectedValue={shipperCompanyId}
            values={shipperCompaniesList}
            onChange={value => {
              setShipperCompanyId(value);
            }}
            getErrors={getFieldErrors}
            style={{width: "100%"}}
          />
        </Col>

        <Col lg={12} md={24} sm={24} sx={24}>
          <SelectField
            title={i18n.t('consignorPage.createDelivery.content.distributionCenterId')}
            name="distributionCenterId"
            selectedValue={distributionCenterId}
            values={distributionCenterList}
            onChange={value => {
              setDistributionCenterId(value);
            }}
            getErrors={getFieldErrors}
            style={{width: "100%"}}
          />
        </Col>
      </Row>

      {isMultimodal &&
      <>
      <Row>
        <Col lg={24} md={24} sm={24} sx={24}>
          <Checkbox
              name="sameConsignee"
              checked={sameConsignee}
              onChange={(e) => {
                  setSameConsignee(e.target.checked);
                  if(e.target.checked) {
                    setConsignee(null);
                  }
              }}
              style={{fontSize: "10pt", paddingTop: "15px"}}
          >
            {i18n.t('consignorPage.createDelivery.content.sameConsignee')}
          </Checkbox>
        </Col>
      </Row>
      {!sameConsignee &&
      <Row>
        <Col lg={24} md={24} sm={24} sx={24}>
          <FieldBlock name={"consignor"} getErrors={getFieldErrors}>
            <span className="form-field-label">{i18n.t('consignorPage.createDelivery.content.consignee')}</span>
            <TextArea
              placeholder={i18n.t('consignorPage.createDelivery.content.consignee')}
              value={consignee}
              onChange={(e) => {
                setConsignee(e.target.value)
              }}
              autoSize={{minRows: 4, maxRows: 8}}
            />
          </FieldBlock>
        </Col>
      </Row>}
      </>}

      <span className="divider-label">{i18n.t('consignorPage.createDelivery.content.divider.cargo')}</span>
      <DividerBlock style={dividerStyle}/>
      <Row gutter={[16, 24]}>
        <Col lg={12} md={24} sm={24} sx={24}>
          <FieldBlock name={"numberDelivery"} getErrors={getFieldErrors} style={{margin: 0, padding: 0}}>
            <NumberInputField
              name="number" label={i18n.t('consignorPage.createDelivery.content.number')}
              value={number} setValue={setNumber}
              getFieldErrors={getFieldErrors}
            />
          </FieldBlock>
        </Col>

        <Col lg={12} md={24} sm={24} sx={24}>
          <FieldBlock getErrors={getFieldErrors} style={{margin: 0, padding: 0}}>
            <SelectField
              title={i18n.t('consignorPage.createDelivery.content.packageType')}
              name="packageType"
              selectedValue={packageType}
              values={packageTypesList}
              onChange={value => {
                setPackageType(value);
              }}
              getErrors={getFieldErrors}
              style={{width: "100%"}}
            />
          </FieldBlock>
        </Col>
      </Row>

      {hasExtendedFields && <>
        <Row gutter={[16, 24]} >
          {isMultimodal &&
            <Col lg={12} md={24} sm={24} sx={24}>
              <InputField
                name="number" label={i18n.t('consignorPage.createDelivery.content.number1C')}
                value={number1C} setValue={setNumber1C}
                getFieldErrors={getFieldErrors}
              />
            </Col>}
          <Col lg={isMultimodal ? 12 : 24} md={24} sm={24} sx={24}>
            <InputField
              label={i18n.t('consignorPage.createDelivery.content.cargoName')}
              name="cargoName"
              value={cargoName}
              setValue={setCargoName}
              getFieldErrors={getFieldErrors}
            />
          </Col>
        </Row>
      </>}

      {isMultimodal && <Row gutter={[16, 24]} >
        <Col lg={12} md={24} sm={24} sx={24}>
          <InputField
            label="Упаковка, количество мест"
            name="packageDesc"
            value={packageDesc}
            setValue={setPackageDesc}
            getFieldErrors={getFieldErrors}
          />
        </Col>
        <Col lg={12} md={24} sm={24} sx={24}>
          <InputField
            label="Размер упаковки"
            name="packageSize"
            value={packageSize}
            setValue={setPackageSize}
            getFieldErrors={getFieldErrors}
          />
        </Col>
        <Col lg={24} md={24} sm={24} sx={24}>
          <InputField
            label="Вес брутто/нетто"
            name="weightDesc"
            value={weightDesc}
            setValue={setWeightDesc}
            getFieldErrors={getFieldErrors}
          />
        </Col>
      </Row>}

      <Row gutter={[16, 24]}>
        <Col lg={8} md={24} sm={24} sx={24}>
          <NumberInputField
            name="weight" label={i18n.t('consignorPage.createDelivery.content.weight')}
            value={weight} setValue={setWeight}
            getFieldErrors={getFieldErrors}
          />
        </Col>

        <Col lg={8} md={24} sm={24} sx={24}>
          <NumberInputField
            name="volume" label={i18n.t('consignorPage.createDelivery.content.volume')}
            value={volume} setValue={setVolume}
            getFieldErrors={getFieldErrors}
          />
        </Col>

        <Col lg={8} md={24} sm={24} sx={24}>
          <NumberInputField
            name="assessedValue" label={i18n.t('consignorPage.createDelivery.content.assessedValue')}
            value={assessedValue} setValue={setAssessedValue}
            getFieldErrors={getFieldErrors}
          />
        </Col>

      </Row>

      {deliveryType !== DELIVERY_AUCTION_PRICE_TYPE 
        && deliveryType !== REDUCTION_TYPE 
        && deliveryType !== AUCTION_MULTIMODAL_TYPE  
        && deliveryType !== DELIVERY_MULTIMODAL_TYPE
        &&
        <>
          <span className="divider-label">{i18n.t('consignorPage.createDelivery.content.divider.price')}</span>
          <DividerBlock style={dividerStyle}/>
          <Row gutter={[16, 24]}>
            <Col lg={8} md={24} sm={24} sx={24}>
              <NumberInputField
                name="ndsPrice" label={i18n.t('consignorPage.createDelivery.content.ndsPrice')}
                value={ndsPrice}
                setValue={setNdsPrice}
                onBlur={() => updatePrices(ndsPrice, 'nds')}
                getFieldErrors={getFieldErrors}
              />
            </Col>

            <Col lg={8} md={24} sm={24} sx={24}>
              <NumberInputField
                name="noNdsPrice" label={i18n.t('consignorPage.createDelivery.content.noNdsPrice')}
                percent={20}
                value={noNdsPrice}
                setValue={setNoNdsPrice}
                onBlur={() => updatePrices(noNdsPrice, 'no-nds')}
                getFieldErrors={getFieldErrors}
              />
            </Col>

            <Col lg={8} md={24} sm={24} sx={24}>
              <NumberInputField
                name="cashPrice" label={i18n.t('consignorPage.createDelivery.content.cashPrice')}
                value={cashPrice}
                setValue={setCashPrice}
                onBlur={() => updatePrices(cashPrice, 'cash')}
                getFieldErrors={getFieldErrors}
              />
            </Col>

          </Row>

          <Row gutter={[16, 24]}>
            <Col lg={8} md={24} sm={24} sx={24}>
              <NumberInputField
                name="nds5Price" label={i18n.t('consignorPage.createDelivery.content.nds5Price')}
                value={nds5Price}
                setValue={setNds5Price}
                onBlur={() => updatePrices(nds5Price, 'nds-5')}
                getFieldErrors={getFieldErrors}
              />
            </Col>

            <Col lg={8} md={24} sm={24} sx={24}>
              <NumberInputField
                name="nds7Price" label={i18n.t('consignorPage.createDelivery.content.nds7Price')}
                value={nds7Price}
                setValue={setNds7Price}
                onBlur={() => updatePrices(nds7Price, 'nds-7')}
                getFieldErrors={getFieldErrors}
              />
            </Col>
          </Row>
        </>}
      {!tenderToDelivery &&
        <Row gutter={[16, 24]}>
          <Col lg={12} md={24} sm={24} sx={24}>
              <Checkbox
                  name="isMulticost"
                  checked={isMulticost}
                  onChange={(e) => {
                      setIsMulticost(e.target.checked);
                  }}
                  disabled={isMultimodal}
                  style={{fontSize: "10pt", paddingTop: "15px"}}
              >
                {i18n.t('consignorPage.createDelivery.content.isMulticost')}
              </Checkbox>
          </Col>
        </Row>
      }
      {renderMulticost()}
      {renderTender()}
      <span className="divider-label">{i18n.t('consignorPage.createDelivery.content.divider.additional')}</span>
      <DividerBlock style={dividerStyle}/>

      <Row gutter={[16, 24]}>
        {!isMultimodal && <>
        <Col lg={12} md={24} sm={24} sx={24}>
          <SelectField
            title={i18n.t('consignorPage.createDelivery.content.loadingType')}
            name="loadingType"
            selectedValue={loadingType}
            values={loadingTypesList}
            onChange={value => {
              setLoadingType(value);
            }}
            getErrors={getFieldErrors}
            style={{width: "100%"}}
          />
        </Col>

        <Col lg={24} md={24} sm={24} sx={24}>
          <SelectField
            name="type"
            mode="multiple"
            title={i18n.t('consignorPage.createDelivery.content.type')}
            values={translatedCarcassTypes}
            selectedValue={allowedCarcassTypes}
            onChange={(value) => {
              setAllowedCarcassTypes(value);
            }}
            getErrors={getFieldErrors}
            style={{width: "100%"}}
          />
        </Col>
        </>}
        {isMultimodal && <Col lg={12} md={24} sm={24} sx={24}>
          <SelectField
            name="transportationType"
            mode="multiple"
            title="Тип отправки"
            values={transportationTypesList}
            selectedValue={transportationType}
            onChange={(value) => {
              setTransportationType(value);
            }}
            getErrors={getFieldErrors}
            style={{width: "100%"}}
          />
        </Col> }

        <Col lg={24} md={24} sm={24} sx={24}>
          <TextArea
            placeholder={i18n.t('consignorPage.createDelivery.content.comments')}
            value={comments}
            onChange={(e) => {
              setComments(e.target.value)
            }}
            autoSize={{minRows: 4, maxRows: 8}}
          />
        </Col>
      </Row>

      {deliveryType === DELIVERY_DEFAULT_TYPE &&
        <Row gutter={[16, 24]}>
          <Col lg={12} md={24} sm={24} sx={24}>
            <Checkbox
              name="needUpdateDate"
              checked={needUpdateDate}
              onChange={(e) => {
                setNeedUpdateDate(e.target.checked);
              }}
              style={{fontSize: "10pt", paddingTop: "15px"}}
            >
              {i18n.t('consignorPage.createDelivery.content.needUpdateDate')}
            </Checkbox>
          </Col>
        </Row>}

      {isMultimodal &&
        <Equipments 
          equipments={equipments} 
          setEquipments={setEquipments} 
          pointEquipments={pointEquipments} 
          setPointEquipments={setPointEquipments} 
          fieldsErrors={fieldsErrors}
          translatedCarcassTypes={translatedCarcassTypes}
        />
      }

      <span className="divider-label">{i18n.t('consignorPage.createDelivery.content.divider.pointsOnLoad')}</span>
      <DividerBlock style={dividerStyle}/>
      <>
        {renderPoints(points, setPoints, maxPointsLoad, setMaxPointsLoad, 'load')}
      </>
      <>
        {renderPointsAddButton(points, setPoints, 'load', maxPointsLoad, setMaxPointsLoad)}
      </>

      <span className="divider-label">{i18n.t('consignorPage.createDelivery.content.divider.pointUpLoad')}</span>
      <DividerBlock style={dividerStyle}/>
      <>
        {renderPoints(points, setPoints, maxPointsUnload, setMaxPointsUnload, 'unload')}
      </>
      <>
        {renderPointsAddButton(points, setPoints, 'unload', maxPointsUnload, setMaxPointsUnload)}
      </>

      <Row gutter={[16, 24]}>
        <Col lg={24} md={24} sm={24} sx={24} style={{textAlign: 'center'}}>
          <Button type="primary" size="large" htmlType="button"
                  onClick={tenderToDelivery ? turnTenderToDelivery : saveDelivery}
                  style={{margin: '0 5px 10px 0', ...bigButtonStyle}}>{i18n.t('main.buttons.create')}</Button>
        </Col>
      </Row>
      <MapPointSelectModal
        isShow={showMap}
        setIsShow={setShowMap}
        countryList={translatedCountryList}
        pointGuid={mapPointGuid}
        updatePoint={updatePointsPoint}
      />
    </Spinner>
  );

}
